import { useSuspenseQuery } from '@tanstack/react-query';
import { networkCountQueryOptions } from '#api/networks.queries.ts';
import { useSuspenseFeatureFlagsQuery } from '#api/org.queries.ts';

/**
 * A feature flag controls how many networks can be created for each account, so we need
 * to be able to tell whether the user can create another network or not.
 */
export function useSuspenseIsNetworkLimitReached() {
  const { NETWORK_LIMIT } = useSuspenseFeatureFlagsQuery().data;
  const { data: networkCount } = useSuspenseQuery(networkCountQueryOptions);

  // This should be defined, but if the API does not yet support, treat as no limit
  if (NETWORK_LIMIT === undefined) {
    return {
      isNetworkLimitReached: false,
      networkLimit: Number.POSITIVE_INFINITY,
    };
  }

  return {
    /** Have we reached or surpassed the {@link NETWORK_LIMIT}? */
    isNetworkLimitReached: networkCount >= NETWORK_LIMIT,
    networkLimit: NETWORK_LIMIT,
  };
}
